SearchActions = LP.module('Searches').SearchActions

class ResourceModal
  @animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'

  @$selector: ->
    $('#resource-modal')

  @hide: ->
    @$selector().modal 'hide'

  @setContext: (@context) ->

  constructor: (@url, @transition) ->
    @$container = @constructor.$selector()

  show: ->
    modalPromise = $.Deferred()
    if @_isVisible()
      @_animateHide modalPromise
    else if @_isCreated()
      @_removeContent modalPromise
    else
      @_create modalPromise

    if LP.config.new_curriculum_manager
      LP.module('MyCurriculumManagerBase').setModalVisible(true)

    @$container.off('hidden.bs.modal')
    @$container.modal('show').on('hidden.bs.modal', @_hidden)

    ajaxPromise = $.get @url.replace(/(\?|$)/, '.json$1')
    $.when(ajaxPromise, modalPromise).then(@_loaded).fail(@_redirect)

  _hidden: =>
    if LP.config.new_curriculum_manager
      LP.module('MyCurriculumManagerBase').setModalVisible(false)
    $('.popover.in').popover('hide')
    if c = @constructor.context
      c.executeAction SearchActions.hideResource
    @_reset_iframe_src()

  # Fix for - videos keep playing after closing the RRP
  _reset_iframe_src: =>
    iFrame = @$container.find('iframe')
    iFrame.attr('src', iFrame.attr('src'))

  _loaded: (ajaxResponse, modalResponse) =>
    data = ajaxResponse[0]
    if data.page?
      @$container.addClass(@_animationClassIn()).html(data.page)
    else
      @_redirect()

    @$container.one @constructor.animationEnd, =>
      @$container.removeClass @_animationClassIn()
    @$container.find('.js-resource-row').append @_closeButton()

    if @$container.find('.row.shared_collection')[0]
      LP.module('SharedCollections').show()
    else
      LP.module('Resources').show()

    $('.modal-backdrop, #resource-modal .js-resource-row').on 'click', @_closeModal
    $('.middle-resource .concepts > *').on('click', @_onConceptClick)
    $('.middle-resource .keyterms > *').on('click', @_onKeytermClick)

    if localStorage.getItem('showInModal') == 'yes'
      $('.new-rrp a.upgrade').attr('data-remote', 'true');

  _onConceptClick: (e) =>
    @_handleTagClick('concept_ids', e.target.dataset['conceptId'], ['keywords', 'keyterm_ids'])

  _onKeytermClick: (e) =>
    @_handleTagClick('keyterm_ids', e.target.dataset['keytermId'], ['keywords', 'concept_ids'])

  _handleTagClick: (paramName, paramValue, paramsToClear) =>
    context = @constructor.context
    return true unless context.hasStore('ParamStore')
    params = context.getStore('ParamStore').getAll()
    $.each paramsToClear, (index, param) ->
      params[param] = ''
    params[paramName]  = paramValue
    context.executeAction(SearchActions.setParams, params)
    window.scrollTo(0,0)
    return false

  _closeModal: (e) ->
    return unless e.target is e.currentTarget
    $('.resource-modal-close').click()

  _hide: (e) =>
    return unless e.target is e.currentTarget
    @$container.modal 'hide'

  _modalContainer: ->
    '<div class="modal container fade animated js-no-stackable-modal" id="resource-modal">' + @_spinner() + '</div>'

  _spinner: ->
    '<div class="spin-wrapper">
       <i class="fa-solid fa-arrows-rotate fa-spin fa-4x" />
     </div>'

  _closeButton: ->
    '<button class="btn btn-lg btn-default resource-modal-close" type="button" data-dismiss="modal">
       <i class="fa-solid fa-lg fa-xmark" />
     </button>'

  _isCreated: ->
    @$container.length

  _isVisible: ->
    @$container.is(':visible')

  _create: (promise) ->
    @$container = $(@_modalContainer()).appendTo 'body'
    promise.resolve()

  _removeContent: (promise) ->
    @$container.html @_spinner()
    promise.resolve()

  _animateHide: (promise) ->
    $('.popover.in').popover('hide')
    @$container.addClass(@_animationClassOut()).one @constructor.animationEnd, =>
      @$container.removeClass @_animationClassOut()
      @$container.scrollTop(0)
      @$container.html @_spinner()
      promise.resolve()

  _animationClassIn: ->
    switch @transition
      when 'left' then 'bounceInLeft'
      when 'right' then 'bounceInRight'
      else 'bounceInUp'

  _animationClassOut: ->
    switch @transition
      when 'left' then 'bounceOutRight'
      when 'right' then 'bounceOutLeft'
      else 'bounceOutUp'

  _redirect: ->
    document.location.href = @url.replace('.json', '')

  $(window).on 'popstate': ->
    window.history.go(0) if LP.config.static_resource_page

LP.module('Resources').ResourceModal = ResourceModal
